import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ximg-fade" }

import { ref, watch } from 'vue';

import XImg from '@components/frame/XImg.vue';

interface ILayer {
  id: number;
  url: string;
  loaded: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'XImgFade',
  props: {
    src: {},
    duration: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v11632c95": (_ctx.duration)
}))

const props = __props;

let seq = 0;
const layers = ref<ILayer[]>([]);

watch(
  () => props.src,
  (url) => {
    if (!url) return;
    const top = layers.value[layers.value.length - 1];
    if (top && top.url === url) return;
    layers.value.push({ id: ++seq, url, loaded: false });
    if (layers.value.length > 3) layers.value.splice(0, layers.value.length - 3);
  },
  { immediate: true },
);

function onLayerLoad(layer: ILayer) {
  layer.loaded = true;
  const id = layer.id;
  window.setTimeout(() => {
    const idx = layers.value.findIndex((l) => l.id === id);
    if (idx > 0) layers.value.splice(0, idx);
  }, parseFloat(props.duration));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(layers.value, (layer) => {
      return (_openBlock(), _createElementBlock("div", {
        key: layer.id,
        class: _normalizeClass(["fill-block layer", { show: layer.loaded }])
      }, [
        _createVNode(XImg, {
          class: "fill-block",
          src: layer.url,
          onLoad: ($event: any) => (onLayerLoad(layer))
        }, null, 8, ["src", "onLoad"])
      ], 2))
    }), 128))
  ]))
}
}

})